import { render } from "./Transacciones.vue?vue&type=template&id=671700b2&scoped=true"
import script from "./Transacciones.vue?vue&type=script&lang=js"
export * from "./Transacciones.vue?vue&type=script&lang=js"

import "./Transacciones.vue?vue&type=style&index=0&id=671700b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671700b2"]])

export default __exports__